export default {
  type: 'applications',
  name: 'Application',
  permissions: {
    view: { app: 'base_role', role: 'postgraphile_infrastructure' },
    insert: { app: 'people', role: 'people' },
    update: { app: 'people', role: 'people' },
    delete: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allApplications',
    orderBy: {
      type: 'ApplicationsOrderBy',
      default: 'APPLICATION_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'applicationName',
        label: 'Name',
        searchable: false,
        order: 'APPLICATION_NAME'
      },
      {
        name: 'applicationDesc',
        label: 'Description',
        searchable: false,
        order: 'APPLICATION_DESC'
      },
      {
        name: 'applicationSnEmail',
        label: 'ServiceNow Email',
        searchable: false,
        order: 'APPLICATION_SN_EMAIL'
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'applicationId',
        type: 'Int',
        required: true
      },
      { field: 'applicationName', required: true },
      'applicationDesc',
      'applicationUrl',
      'applicationSnEmail',
      'applicationNotes'
    ],
    key: ['applicationId'],
    input: 'application',
    create: 'createApplication',
    delete: 'deleteApplication',
    update: 'updateApplication'
  },
  load: {
    nodeId: 'application',
    key: 'applicationByApplicationId'
  },
  form: {
    createHeader: 'Create Application',
    editHeader: 'Edit Application - ${applicationName}',
    printHeader: 'Application - ${applicationName}',
    schema: [
      {
        name: 'applicationName',
        label: 'Name',
        labelWidth: 2,
        required: true
      },
      {
        name: 'applicationDesc',
        label: 'Description',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        name: 'applicationUrl',
        label: 'URL',
        labelWidth: 2
      },
      {
        name: 'applicationSnEmail',
        label: 'ServiceNow Email',
        labelWidth: 2
      },
      {
        name: 'applicationNotes',
        label: 'Notes',
        labelWidth: 2,
        type: 'textarea'
      }
    ],
    audit: {
      lookup: 'allApplicationAudits',
      orderBy: { type: 'ApplicationAuditsOrderBy', value: 'EVENT_TIME_ASC' },
      dbTableHeaders: [
        {
          value: 'application_access_info',
          header: 'Access Type:',
          headerField: 'accessType'
        },
        {
          value: 'application_link',
          header: 'Link:',
          headerField: 'linkUrl'
        },
        {
          value: 'application_people',
          header: 'Person:',
          headerField: 'personNameAccount'
        },
        {
          value: 'application_group',
          header: 'Group:',
          headerField: 'groupName'
        }
      ],
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    },
    print: {
      permissions: {
        view: { app: 'people', role: 'people' }
      }
    }
  },
  joinTables: [
    {
      label: 'Access Information',
      addType: 'form',
      addForm: [
        { field: 'accessType', name: 'accessType', required: true },
        {
          field: 'accessDesc',
          name: 'accessDesc',
          label: 'Description',
          fieldType: 'String',
          type: 'textarea'
        },
        {
          field: 'accessGranted',
          name: 'accessGranted',
          label: 'Granted Via',
          fieldType: 'String',
          type: 'textarea'
        }
      ],
      removeLabel: 'Remove ${accessType} from this application access?',
      lookup: 'allApplicationAccesses',
      fields: [
        { field: 'accessType', required: true, show: false },
        { field: 'accessType', alias: 'type' },
        { field: 'accessDesc', alias: 'description' },
        { field: 'accessGranted', alias: 'grantedVia' }
      ],
      create: 'createApplicationAccess',
      delete: 'deleteApplicationAccess',
      input: 'applicationAccess'
    },
    {
      label: 'Additional Links',
      addLabel: 'Add Additional Link',
      addType: 'form',
      addForm: [
        { field: 'linkUrl', name: 'linkUrl', label: 'Link', required: true },
        {
          field: 'linkDesc',
          name: 'linkDesc',
          label: 'Description',
          fieldType: 'String',
          type: 'textarea'
        }
      ],
      removeLabel: 'Remove ${linkUrl} from this application access?',
      lookup: 'allApplicationLinks',
      fields: [
        { field: 'linkUrl', label: 'Link', required: true },
        { field: 'linkDesc', alias: 'description' }
      ],
      create: 'createApplicationLink',
      delete: 'deleteApplicationLink',
      input: 'applicationLink'
    },
    {
      label: 'Owner / Administrator',
      removeLabel:
        'Remove ${roleByRoleName.recordId} from this application owner/admin?',
      lookup: 'allApplicationRoles',
      join: 'roleByRoleName',
      fields: [
        {
          field: 'roleName',
          name: 'roleName',
          required: true
        },
        'roleTitle',
        'members',
        {
          field: 'roleName',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'roles'
        },
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      create: 'createApplicationRole',
      delete: 'deleteApplicationRole',
      input: 'applicationRole',
      formType: 'roles',
      multiHeader: 'Added ${roleName} to application owner/admin'
    },
    {
      label: 'Associated Groups',
      addLabel: 'Add Group',
      removeLabel: 'Remove ${groupByGroupId.groupName} from this application?',
      lookup: 'allApplicationGroups',
      join: 'groupByGroupId',
      fields: [
        {
          field: 'groupId',
          type: 'Int',
          required: true,
          show: false
        },
        'groupName',
        'groupDescription',
        {
          field: 'groupId',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'groups'
        },
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      create: 'createApplicationGroup',
      delete: 'deleteApplicationGroup',
      input: 'applicationGroup',
      formType: 'groups',
      multiHeader: 'Added ${groupName} to application'
    }
  ]
}
